export function fuseauComplement(fuseau) {
    if (!fuseau || typeof fuseau !== 'string') throw new Error('fuseau non réglé')
    try {
        new Intl.DateTimeFormat('fr-FR', { timeZone: fuseau }).format(0)
    } catch (error) {
        throw new Error('fuseau non réglé')
    }
    return fuseau
}

export function dateComplement(instant, fuseau, annee = true) {
    const date = new Date(instant)
    if (!instant || Number.isNaN(date.getTime())) return 'Date non renseignée'
    const parties = {}
    new Intl.DateTimeFormat('fr-FR', {
        timeZone: fuseauComplement(fuseau),
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    })
        .formatToParts(date)
        .forEach((partie) => {
            parties[partie.type] = partie.value
        })
    return parties.day + '/' + parties.month + (annee ? '/' + parties.year : '') + ' ' + parties.hour + ':' + parties.minute
}
